import { render, staticRenderFns } from "./ModalMesasInformadas.vue?vue&type=template&id=0a4663bc"
import script from "./ModalMesasInformadas.vue?vue&type=script&lang=js"
export * from "./ModalMesasInformadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports